import { createAction, createReducer, createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import type { ExtraSpec, View } from "@mapka/style-editor";

export const setStyleEditorView = createAction<View>("style/setStyleEditorView");
export const setExtraSpec = createAction<ExtraSpec | undefined>("style/setExtraPartialStyle");

export interface StyleState {
  view: View;
  extraSpec?: ExtraSpec;
}

const views: View[] = [
  "ai",
  "versions",
  "layers",
  "markers",
  "sources",
  "settings",
];

const initialState: StyleState = {
  view: views.find(view => location.pathname.endsWith(view)) ?? "ai",
};

export const styleReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setStyleEditorView, (state, { payload }) => {
      state.view = payload;
    })
    .addCase(setExtraSpec, (state, { payload }) => {
      // @ts-expect-error Typescript and immer causing issues
      state.extraSpec = payload;
    });
});

export const getStyleStateSelector = createSelector(
  (state: RootState) => state,
  state => state.style,
);

export const getStyleEditorViewSelector = createSelector(
  getStyleStateSelector,
  style => style.view,
);

export const getExtraSpec = createSelector(
  getStyleStateSelector,
  style => style.extraSpec,
);
